export default {
  text: 'text',
  password: 'password',
  checkbox: 'checkbox',
  radio: 'radio',
  number: 'number',
  textarea: 'textarea',
  select: 'select',
  multicheckbox: 'multi-checkbox',
  date: 'date',
  rangeDatePicker: 'range-date-picker',
  rangeDatePickerFirstInput: 'range-date-picker-first-input',
  selectFieldWithAdditions: 'selectFieldWithAdditions',
  float: 'float',
}
